module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - daedap.0bcbc90a.pdf";